import axios from 'axios';
import { ICityModel, IIbgeCity } from 'entities';
import { convertIbgeCityToICity } from '../../utils/convertIbgeCityToICity';
import { slugify } from '../../utils/slugify';

const BASE_URL = 'https://servicodados.ibge.gov.br/api/v1';

// TODO - Realizar a busca dessas informações na API do hub para evitar bugs
export const getCitiesByState = async (state: string) => {
  const url = `${BASE_URL}/localidades/estados/${state}/municipios`;
  return (await axios
    .get(url)
    .then(({ data }) => [
      ...data.map((c: IIbgeCity) => convertIbgeCityToICity(c)),
    ])) as ICityModel[];
};
export const getCodeByName = (name: string, uf: string): Promise<ICityModel | undefined> => {
  const url = `${BASE_URL}/localidades/municipios/${name}`;
  return axios
    .get<IIbgeCity[] | IIbgeCity>(url)
    .then(({ data }) => {
      if (Array.isArray(data)) {
        const filteredData = data.find(
          (d) => slugify(d.nome) === name && slugify(d.microrregiao.mesorregiao.UF.sigla) === uf,
        );
        if (!filteredData) {
          return undefined;
        }
        const convertedCity = convertIbgeCityToICity(filteredData);
        return convertedCity;
      }
      const convertedCity = convertIbgeCityToICity(data as IIbgeCity);
      return convertedCity;
    })
    .catch(() => {
      return undefined;
    });
};

export const getCitiesByMicroRegion = async (microRegion: number) => {
  const url = `${BASE_URL}/localidades/microrregioes/${microRegion}/municipios`;
  return (await axios
    .get(url)
    .then(({ data }) => [
      ...data.map((c: IIbgeCity) => convertIbgeCityToICity(c)),
    ])) as ICityModel[];
};
